import { APP_ERROR_NOTIFICATION_API } from "../../constants/_api";
import _query from "../../actions/_query";

export const errorNotification = async(token, info) => {
  info = info || {};
  let url = APP_ERROR_NOTIFICATION_API;
  try {
    let result = await _query(url, token, "POST", info);
    result = await result.json();
    return result.body.results;
  }
  catch(err) {
    console.log(err);
  }
}